var React = require('react');

function IconWindowsClient (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.57143 11.2817V5.292L9.73028 4.24543V11.2826H2.57143V11.2817ZM2.57143 12.7131V18.5846L9.73028 19.6783V12.7131H2.57143ZM11.1617 12.7131V19.8977L21.1817 21.4286V12.7131H11.1617ZM21.1817 11.2817V2.57143L11.1617 4.03629V11.2817H21.1817Z","fill":"currentColor"}));
}

IconWindowsClient.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconWindowsClient;

IconWindowsClient.default = IconWindowsClient;
